import { localStorageGetItem } from 'src/utils/local-storage';

import { PresentationExportFormat } from 'src/services/presentations/presentations.types';

import { downloadFromUrl } from './use-presentation-preview';

/**
 * Downloads a Word template filled with a made-up candidate (JT1-1887). Binary, so fetch rather than
 * RTK Query, as the preview does. Rejects with the server's error code when there is one.
 */
export async function downloadTestRender(templateId: string, format: PresentationExportFormat): Promise<void> {
  const response = await fetch(`${import.meta.env.VITE_BACKEND_URL}/presentation-templates/${templateId}/test-render`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${localStorageGetItem('access_token', undefined)}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ format }),
  });
  if (!response.ok) {
    const body = await response.json().catch(() => null);
    throw Object.assign(new Error(`test render ${response.status}`), { data: body });
  }
  const name = response.headers.get('content-disposition')?.match(/filename="([^"]+)"/)?.[1] ?? `Test.${format}`;
  const url = URL.createObjectURL(await response.blob());
  downloadFromUrl(url, name);
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
